import React from "react";
import { colors, semanticColors, brandColors } from "lib/constants/colors";
import { makeStyles } from "@material-ui/core/styles";

type SubscriptionStatus =
  | "active"
  | "in_trial"
  | "canceled"
  | "paused"
  | "non_renewing"
  | null;

interface StatusConfig {
  color: string;
  background: string;
}

interface SubscriptionStatusBadgeProps {
  status: SubscriptionStatus;
}

const useStyles = makeStyles({
  badge: {
    display: "inline-block",
    padding: "3px 8px",
    borderRadius: "12px",
    fontSize: "10px",
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
});

const getStatusConfig = (status: SubscriptionStatus): StatusConfig => {
  switch (status) {
    case "active":
      return {
        color: colors.mintColor[7],
        background: colors.mintColor[1],
      };
    case "in_trial":
      return {
        color: colors.skyColor[7],
        background: colors.skyColor[1],
      };
    case "canceled":
      return {
        color: colors.redMagenta[7],
        background: colors.redMagenta[1],
      };
    case "paused":
      return {
        color: colors.softOrange[7],
        background: colors.softOrange[1],
      };
    case "non_renewing":
      return {
        color: colors.mediumPurple[7],
        background: colors.mediumPurple[1],
      };
    default:
      return {
        color: semanticColors.text,
        background: brandColors.cementGray,
      };
  }
};

export const SubscriptionStatusBadge: React.FC<
  SubscriptionStatusBadgeProps
> = ({ status }) => {
  const classes = useStyles();
  const { color, background } = getStatusConfig(status);

  return (
    <span
      className={classes.badge}
      style={{
        color,
        backgroundColor: background,
      }}
    >
      {status ? status.replace(/_/g, " ") : "No Subscription"}
    </span>
  );
};
